<button
  class="ds-button"
  [ngClass]="{
    'size-small': size === 'small',
    'type-primary': variant === 'primary',
    'type-outline': variant === 'outline',
    'is-loading': isLoading,
    'full-width': width === 'full'
  }"
  [attr.type]="type"
  [attr.tabindex]="tabIndex"
  [disabled]="disabled || isLoading"
  (click)="clicked.emit($event)"
>
  <app-ds-icon
    *ngIf="isLoading"
    class="loading-icon"
    name="loader-circle"
    [size]="iconSizeSet[size]"
    [color]="variant === 'primary' ? 'var(--color-core-neutral-0)' : 'var(--color-core-neutral-5)'"
  ></app-ds-icon>
  <app-ds-icon
    *ngIf="icon && variant === 'outline' && !isLoading"
    [name]="icon"
    [size]="iconSizeSet[size]"
    [color]="iconColorSet[disabled ? 'disabled' : variant]"
  ></app-ds-icon>
  <ng-content></ng-content>
</button>
